import { NewsletterModal } from './NewsletterModal';

export default NewsletterModal;
